import FlowNode from './FlowNode';
import FlowConnector from './FlowConnector';

/**
 * Renders a condition branch as two columns (Yes / No).
 * Each branch shows its chain of steps until a convergence point.
 */
export default function FlowBranch({ conditionStep, steps, selectedNodeId, onNodeClick }) {
  // Collect steps for each branch
  function collectBranch(startId) {
    const branch = [];
    if (!startId) return branch;

    const startStep = steps.find(s => s.id === startId);
    if (!startStep) return branch;

    // Walk from the start step, following array order until we hit a step
    // that's referenced by another condition or is an exit
    const startIdx = steps.indexOf(startStep);
    if (startIdx === -1) return [startStep];

    // Simple approach: collect the start step only
    // (for branching, each branch typically has one step before converging)
    branch.push(startStep);
    return branch;
  }

  const trueBranch = collectBranch(conditionStep.trueBranch);
  const falseBranch = collectBranch(conditionStep.falseBranch);

  if (trueBranch.length === 0 && falseBranch.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      {/* SVG connectors */}
      <svg className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-8" viewBox="0 0 600 32" fill="none" preserveAspectRatio="xMidYMid meet">
        {trueBranch.length > 0 && (
          <path d="M300 0 L150 32" stroke="currentColor" className="text-ink/30" strokeWidth="2" />
        )}
        {falseBranch.length > 0 && (
          <path d="M300 0 L450 32" stroke="currentColor" className="text-ink/30" strokeWidth="2" />
        )}
      </svg>

      <div className="pt-8 flex gap-4 justify-center">
        {/* True (Yes) branch */}
        <div className="flex flex-col items-center min-w-[18rem]">
          <span className="text-xs font-bold text-success mb-2">Yes</span>
          {trueBranch.map((step, i) => (
            <div key={step.id}>
              {i > 0 && <FlowConnector />}
              <FlowNode
                step={step}
                selected={selectedNodeId === step.id}
                onClick={onNodeClick}
              />
            </div>
          ))}
        </div>

        {/* False (No) branch */}
        <div className="flex flex-col items-center min-w-[18rem]">
          <span className="text-xs font-bold text-alert mb-2">No</span>
          {falseBranch.map((step, i) => (
            <div key={step.id}>
              {i > 0 && <FlowConnector />}
              <FlowNode
                step={step}
                selected={selectedNodeId === step.id}
                onClick={onNodeClick}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Convergence connector */}
      <svg className="mx-auto w-full h-8" viewBox="0 0 600 32" fill="none" preserveAspectRatio="xMidYMid meet">
        {trueBranch.length > 0 && (
          <path d="M150 0 L300 32" stroke="currentColor" className="text-ink/30" strokeWidth="2" />
        )}
        {falseBranch.length > 0 && (
          <path d="M450 0 L300 32" stroke="currentColor" className="text-ink/30" strokeWidth="2" />
        )}
      </svg>
    </div>
  );
}
